<div class="container justify-content-center align-items-center min-vh-100" [ngClass]="{'d-flex' : !isJobApply}">
  <div class="row overflow-hidden bg-white" [ngClass]="{'justify-content-center align-items-center':isJobApply, 'shadow-lg rounded-4':!isJobApply}" style="max-width: 900px; width: 100%;">
    
    <!-- Lado visual -->
    <div class="col-md-6 d-none d-md-block p-0" *ngIf="!isJobApply">
      <img src="/assets/img/login.png" alt="Imagen login" class="img-fluid h-100 w-100 object-fit-cover" style="object-position: center;">
    </div>

    <!-- Lado formulario -->
    <div class="p-5" [ngClass]="{'col-md-6':!isJobApply, 'col-md-12':isJobApply}">
      <h4 class="fw-bold mb-4 text-center">Bienvenido de nuevo</h4>
      <p class="text-muted text-center mb-4">Accede a tu cuenta y encuentra tu próxima oportunidad laboral.</p>

      <form [formGroup]="loginForm">
        <!-- Email -->
        <div class="mb-3">
            <label class="form-label fw-semibold">{{'email' | translate}}</label>
            <input type="email" class="form-control" id="email" formControlName="email" placeholder="tucorreo@ejemplo.com" [(ngModel)]="email" required>
            <div *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].touched"
                class="text-danger">
                <small *ngIf="loginForm.controls['email'].errors?.['required']">{{'email-required' |
                    translate}}</small>
                <small *ngIf="loginForm.controls['email'].errors?.['email']">Formato de email
                    inválido</small>
            </div>
        </div>

        <!-- Password -->
        <div class="mb-3">
          <label class="form-label fw-semibold">{{ 'password' | translate }}</label>

          <div class="input-group">
            <input [type]="showPassword ? 'text' : 'password'"
                   class="form-control"
                   id="password"
                   formControlName="password"
                   [(ngModel)]="password"
                   placeholder=""
                   required>

            <button type="button"
                    class="btn btn-outline-secondary"
                    (click)="togglePassword()"
                    tabindex="-1">
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>

          <div *ngIf="loginForm.controls['password'].invalid && loginForm.controls['password'].touched"
               class="text-danger mt-1">
            <small *ngIf="loginForm.controls['password'].errors?.['required']">
              {{ 'password-required' | translate }}
            </small>
          </div>
        </div>


        <!-- Enlaces -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <small class="text-muted">{{'no-account' | translate}} <a routerLink="/registro-cv" class="text-primary fw-semibold">{{'signup-here' | translate}}</a></small>
          <a routerLink="/solicitud-cambio-credenciales" class="text-muted small text-decoration-none">¿Olvidaste tu contraseña?</a>
        </div>

        <!-- Botón -->
        <div class="d-grid">
            <button type="submit" class="btn btn-primary fw-semibold" (click)="login()" [disabled]="loginForm.invalid || isLoading ">
                {{ isLoading ? 'login-loading' : 'login-2' | translate }}
            </button>

        </div>
        <!-- <hr>
        <br>
        <div id="googleBtn"></div>
        <br>
        <a [href]="facebookOAuthUrl" class="facebook-login-btn">
            <i class="fa fa-facebook"></i> Login con Facebook
        </a>
         <br>
        <a href="https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86tks3mmy61hhy&redirect_uri=http://localhost:4200/login&scope=r_liteprofile%20r_emailaddress" class="linkedin-login-btn">
          <i class="fa fa-linkedin"></i> Login con LinkedIn
        </a> -->
      </form>
    </div>
  </div>
</div>

<!-- Modal de Error -->
<div class="modal fade" id="errorModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header bg-danger text-white">
                <h5 class="modal-title">Error</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                {{ errorMessage }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>